/**
 * Terminal Catchball loop states.
 *
 * A loop in one of these states is *closed* for governance purposes: it is the
 * gate `publishPrioritySet` checks before allowing Ratified → Published.
 * Exported so the wayfinding checklist (`RatificationNextSteps`) derives the
 * same answer the gate does instead of re-deciding what "closed" means.
 *
 * Note: `accepted` is deliberately NOT terminal. Since migration 692 a full
 * accept sets `catchball_loops.state = 'accepted'` and stamps `closed_at`, but
 * closing the loop remains a separate, deliberate governance act.
 */
export const TERMINAL_LOOP_STATES: readonly string[] = [
  'closed',
  'DECLINED',
  'declined',
  'FINAL_REJECTED',
  'final_rejected',
  'rejected',
];

export function isTerminalLoopState(state: string | null | undefined): boolean {
  return state != null && TERMINAL_LOOP_STATES.includes(state);
}
